export function DynamicWrapper<C extends React.ComponentType<any>>({
	Wrapper,
	children,
	shouldWrap,
	...props
}: {
	Wrapper: C;
	children: React.ReactNode;
	shouldWrap: boolean;
} & Omit<React.ComponentProps<C>, 'children'>) {
	if (shouldWrap) {
		// @ts-ignore
		return <Wrapper {...props}>{children}</Wrapper>;
	}
	return <>{children}</>;
}
